import { MultiSelectOption } from '@dispatch/shared/types';
import { createContext, useContext, useMemo, useState } from 'react';
import React from 'react'; // needed for mobile

interface AbilityContextI {
  resourceId: string | undefined;
  setResourceId: React.Dispatch<string>;
  isAdjuster: boolean | undefined;
  setIsAdjuster: React.Dispatch<boolean>;
}

const AbilityContext = createContext<AbilityContextI | undefined>(undefined);

function CurrentUserResourceProvider({
  children,
}: {
  children: React.ReactChild;
}) {
  const [resourceId, setResourceId] = useState<string>();
  const [isAdjuster, setIsAdjuster] = useState<boolean>();
  const value = { resourceId, setResourceId, isAdjuster, setIsAdjuster };

  return (
    <AbilityContext.Provider value={value}>{children}</AbilityContext.Provider>
  );
}

function useCurrentUserResource() {
  const context = useContext(AbilityContext);

  if (context === undefined) {
    throw new Error(
      'useCurrentUserResource must be used within a CurrentUserResource provider'
    );
  }
  return context;
}

const useCurrentUserAsResourceId = () => {
  const { resourceId } = useCurrentUserResource();

  const currentUser: MultiSelectOption = useMemo(() => {
    return {
      title: resourceId ?? '',
      value: resourceId ?? '',
    };
  }, [resourceId]);

  return currentUser;
};

export {
  CurrentUserResourceProvider,
  useCurrentUserResource,
  useCurrentUserAsResourceId,
};
